export const getEmailValidationErrorStringKey = (globals, allowShopperIdAsLoginId) => {
  if (globals?.brand_config?.login?.display?.utilize_migration_string_to_enforce_email) {
    return allowShopperIdAsLoginId
      ? 'ENFORCE_EMAIL_SHOPPER_ID_MIGRATION_VALIDATE_ERROR'
      : 'ENFORCE_EMAIL_MIGRATION_VALIDATE_ERROR';
  }
  return 'EMAIL_VALID_FORMAT_ERROR';
};
